<div class="position-relative">
  <label class="d-flex align-items-end" for="{{id}}"><span>{{label}}</span> </label>
  <div class="position-relative">
    <label *ngIf="required" class="form-required text-danger fw-500" for="{{id}}">*</label>
    <select class="form-control input-validate" [formControl]="control">
      <option *ngFor="let o of options" [ngValue]="o.value">{{o.value}}</option>
    </select>
  </div>
  <div [style.height.px]="0">
    <app-msg-erro [control]="control"></app-msg-erro>
  </div>
</div>